import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Card, CardBody, Row, Col, Spinner } from "reactstrap";

const MonthlyProductionStatus = ({
  machineId,
  partId,
  year,
  month,
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
console.log("iiiiiiiiii",machineId,partId,year,month)
  /* ---------------- FETCH FUNCTION ---------------- */
  const fetchMonthlyStatus = useCallback(() => {
    if (!partId || !year || !month) return;

    setLoading(true);
    axios
      .get(
        `https://api.hanoch.in/api/mcc-monthly-production-status/?machine_id=${machineId}&part_id=${partId}&year=${year}&month=${month}`
      )
      .then((res) => {
        setData(res.data || null);
      })
      .catch(() => {
        setData(null);
      })
      .finally(() => setLoading(false));
  }, [machineId, partId, year, month]);

  /* ---------------- INITIAL LOAD + POLLING ---------------- */
  useEffect(() => {
    fetchMonthlyStatus(); // initial fetch

    const intervalId = setInterval(() => {
      fetchMonthlyStatus();
    }, 60000); // ⏱ 1 minute

    return () => clearInterval(intervalId); // cleanup
  }, [fetchMonthlyStatus]);

  if (loading && !data) {
    return (
      <div className="text-center my-3">
        <Spinner size="sm" /> Loading production status...
      </div>
    );
  }

  if (!data) return null;

  /* ---------------- STATUS COLOR ---------------- */
  const statusColor =
    data.status === "COMPLETED"
      ? "success"
      : data.status === "IN_PROGRESS"
      ? "warning"
      : "danger";

  /* ---------------- UI ---------------- */
  return (
    <Row className="mt-3">
      <Col md={2}>
        <StatusCard title="Required Qty" value={data.required_quantity} />
      </Col>

      <Col md={2}>
        <StatusCard title="Produced Qty" value={data.produced_quantity} />
      </Col>

      <Col md={2}>
        <StatusCard title="Remaining Qty" value={data.remaining_quantity} />
      </Col>

      <Col md={3}>
        <StatusCard
          title="Completion"
          value={`${data.completion_percentage}%`}
        />
      </Col>

      <Col md={3}>
        <Card className={`border-${statusColor}`}>
          <CardBody className="text-center">
            <small className="text-muted">Status</small>
            <h5 className={`text-${statusColor} mt-2`}>
              {data.status.replace("_", " ")}
            </h5>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

/* ---------------- REUSABLE CARD ---------------- */
const StatusCard = ({ title, value }) => (
  <Card>
    <CardBody className="text-center">
      <small className="text-muted">{title}</small>
      <h5 className="mt-2">{value?.toLocaleString()}</h5>
    </CardBody>
  </Card>
);

export default MonthlyProductionStatus;
